import * as React from 'react';
import { BaseTableList } from 'components/AgGrid/AgGrid';
import {
  CustomerName,
  PrimaryContact,
  InternalUsers,
  CustomerType,
  internalAccountingLink,
} from './CustomerListCellRenderer';
import { PaddedListWrapper } from 'components/AgGrid/CellRenderer/ListView.styled';
import { useAppSelector } from 'store/hook';
import { type RootState } from 'store';
import CustomerHandler from 'handlers/customer.handler';
import { useTranslation } from 'react-i18next';

export const CustomersList = () => {
  const { t } = useTranslation();
  const customerHhandler = new CustomerHandler();
  const { customers } = useAppSelector(
    (state: RootState) => state.customerReducer
  );

  const [columnDefs] = React.useState([
    {
      field: 'customerName',
      headerName: t('customer_name_views'),
      minWidth: 340,
      cellRenderer: CustomerName,
    },
    {
      field: 'accountNumber',
      headerName: t('account'),
      cellRenderer: internalAccountingLink,
    },
    {
      field: 'customerType',
      headerName: t('loc_importer_col_type'),
      suppressSizeToFit: true,
      cellRenderer: CustomerType,
    },
    {
      field: 'primaryContact',
      headerName: t('primary_customer_contact'),
      cellRenderer: PrimaryContact,
    },
    {
      field: 'phoneNumber',
      headerName: t('customer_phone'),
    },
    {
      field: 'internalUsers',
      headerName: t('assigned_symboticware_user_s'),
      cellRenderer: InternalUsers,
    },
    {
      field: 'unitSystem',
      headerName: t('unit_system_2'),
    },
    // {
    //   field: 'id',
    //   headerName: 'Delete Account',
    //   cellRenderer: DeleteAccount,
    //   cellStyle: { textAlign: 'center' },
    // },
  ]);

  React.useEffect(() => {
    void customerHhandler.getAll();
  }, []);

  return (
    <PaddedListWrapper>
      <BaseTableList rowData={customers} columnDefs={columnDefs} />
    </PaddedListWrapper>
  );
};
